import "./assets/fonts/Avenir-Roman-12.ttf";

import { getManifestFile, getBlankManifest, getBlankHTML } from "./Utilities";
import { getHTMLFile } from "./TemplateFactory";
import ConfirmationScreen from "./ConfirmationScreen";

import React, { useEffect, useState, useRef } from "react";
// import "./App.css";
import "./nav.css";
import "./productPages/pageAndProductContainers.css"; //* moved here from PageElevator PageLFD PagePFD, allows Direct.js and Programmatic.js to sorta "switch" which style were using
import JSZip from "jszip";
import { saveAs } from "file-saver";

import PageElevator from "./pages/PageElevator";
import PageLFD from "./pages/PageLFD";
import PagePFD from "./pages/PagePFD";
import Inputs from "./pages/progInputs";
import ProgResults from "./pages/ProgResults";
import Filename from "./Filename";
import WarningMessage from "./WarningMessage";
import DATA_PRODUCTS from "./DATA_PRODUCTS";
import OpacityContext from "./OpacityContext";
import ElevatorSection from "./ElevatorSection";
import LobbySection from "./LobbySection";

// import { useScreenshot } from "use-screenshot-hook";
import * as htmlToImage from "html-to-image";
import { toPng } from "html-to-image";

import PopUp from "./PopUp";

import { BlackWhiteToggleButton, ContinueButton, BackButton } from "./Buttons";

//* Programmatic.js differs from Direct.js in that it passes additional info, usually something related to programmatic or prog
//* progInputs.js likewise is similar to Inputs.js but specifies some programmatic keywording

export default function Programmatic({ onBackToLanding }) {
  const [bintBGOpacity, setBintBGOpacity] = useState(1);
  // for screen shots
  //const imageRef = useRef(null);
  const [screenshot, setScreenshot] = useState(); // 2
  const [screenshotLobby, setScreenshotLobby] = useState(); // lobby, delete if we dont use this
  const [screenshots, setScreenshots] = useState({
    lobby: null,
    elevator: null
  });

  const [continueButtonDisabled, setContinueButtonDisabled] = useState(false);
  // increases as user hits continue
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  // nav while dropping files 1 or 2 for l p.
  const [currentBuildNavNumber, setCurrentBuildNavNumber] = useState(1);

  const [productIndex, setProductIndex] = useState(4);
  const [inputsCheckButtonPressed, setInputsCheckButtonPressed] = useState(
    false
  );
  const [
    inputsCheckButtonPressedOnce,
    setInputsCheckButtonPressedOnce
  ] = useState(false);

  const [isElevator, setIsElevator] = useState(true);
  const [requiresBlankFile, setRequiresBlankFile] = useState(false);
  const [warningMessageText, setWarningMessageText] = useState("");
  const [
    warningMessageTextShowIcon,
    setWarningMessageTextShowIcon
  ] = useState();

  const [inputValues, setInputValues] = useState({
    isProgrammatic: true,
    creativeID: ""
    //* partner is added in progInputs.js
    //* countryCode is added in progInputs.js
    //* product is added in progInputs.js
  });
  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState("test message");

  const [bintBGColor, setBintBGColor] = useState("000000");
  const [defaultBintBGColor, setDefaultBintBGColor] = useState(false);

  const [shakeDropzoneBGImage, setShakeDropzoneBGImage] = useState(false);

  // Separate filenames for elevator and lobby
  const [filename, setFilename] = useState();
  const [elevatorFilename, setElevatorFilename] = useState();
  const [lobbyFilename, setLobbyFilename] = useState();
  const [blankFilename, setBlankFilename] = useState();
  const [blankFilenameLobby, setBlankFilenameLobby] = useState();

  // dropped images and video files
  const [elevatorFile, setElevatorFile] = useState({}); // 12
  const [lfdFile, setLfdFile] = useState({}); // 13
  const [pfdFile, setPfdFile] = useState({}); // 14
  const [svgFile, setSvgFile] = useState({}); // 15
  const [standardAdFile, setStandardAdFile] = useState({}); // 16

  const [mediaExtensions, setMediaExtensions] = useState({}); // 17
  // const [lobbyAndOneAsset, setLobbyAndOneAsset] = useState(); //29
  // const [lobbyAndOneAssetIsLFD, setLobbyAndOneAssetIsLFD] = useState(); //30

  // const [elevatorFileError, setElevatorFileError] = useState(false);
  // const [lfdFileError, setLfdFileError] = useState(false);
  // const [pfdFileError, setPfdFileError] = useState(false);
  // const [svgFileError, setSvgFileError] = useState(false);
  // const [standardAdFileError, setStandardAdFileError] = useState(false);

  const [allDroppedFilenames, setAllDroppedFilenames] = useState([]);
  const [allDroppedNewFilenames, setAllDroppedNewFilenames] = useState([]);

  const [noBintImages, setNoBintImages] = useState(false);
  const [isBlackText, setIsBlackText] = useState(false);

  // --- Results integration state ---
  const [elevatorResults, setElevatorResults] = useState(null);
  const [lobbyResults, setLobbyResults] = useState(null);

  const handleWarningMessageText = (txt, showIcon) => {
    setWarningMessageText(txt);
    setWarningMessageTextShowIcon(showIcon);
  };

  const handleBackPopUpPress = () => {
    // this only shows from Preview to Results so just set number to 2
    setCurrentPageNumber(2);
    setShowPopUp(false);
    setPopUpMessage("");
  };

  const handleContinueButtonDisabled = bool => {
    setContinueButtonDisabled(bool);
  };

  //* this isn't being called in Direct.js either but it seems to set setMediaExtensions which we need for the file extensions?
  //* split mediaExtensions into two different states for clarity, leaving this code here, but its not going to work
  const handleContinuePopUpPress = () => {
    // this runs when just 1 asset dropped
    // setLobbyAndOneAsset(true);
    // handle mediaExtensions state.
    if (mediaExtensions.landscape) {
      // setLobbyAndOneAssetIsLFD(true);
      const newExtension = mediaExtensions.landscape;
      setMediaExtensions(prevState => ({
        ...prevState,
        portrait: newExtension
      }));
    } else {
      //  setLobbyAndOneAssetIsLFD(false);
      const newExtension = mediaExtensions.portrait;
      setMediaExtensions(prevState => ({
        ...prevState,
        landscape: newExtension
      }));
    }

    setShowPopUp(false);
    setPopUpMessage("");
    okToGoToPageThree();
  };

  // this is called when arriving at Results page (4).  Sets filename and blank filename
  // also used when compiling list of input files and their new names
  //* this is called multiple times so eORl does get defined
  //* getFilename = () does not accept arguments and we need it to for eORl, not sure if inputVals replacing inputValues is the way to go or not, see line below
  const getFilename = (inputVals, eORl, productLabel) => {
    const productNumber = parseInt(inputVals.product);
    const creativeID = inputVals.creativeID;
    const partner = inputVals.partner;
    const countryCode = inputVals.countryCode;
    // accepts eORl as an argument now
    const fsValue = DATA_PRODUCTS.data[productNumber].isFS ? "_fs" : "";
    const product = DATA_PRODUCTS.data[productNumber].label;

    try {
      //* old file name as a reference: `${creativeID}_${duration}_${product}blank_${countryCode}${fsValue}_${eORl}-${product}`,
      if (eORl === "e") {
        setBlankFilename(`${creativeID}_blank_${countryCode}_e-${product}`);
      }
      if (eORl === "l") {
        setBlankFilenameLobby(
          `${creativeID}_blank_${countryCode}_l-${product}`
        );
      }
    } catch {
      console.log("not yet");
    }
    //* old file name as a reference: `${creativeID}_${duration}_${desc}_${countryCode}${fsValue}_${eORl}-${product}`;
    return `${creativeID}_${countryCode}${fsValue}_${eORl}-${product}`;
  };

  //* we need to pass in an aregument for what platform we are expecting so we can hand that off as eORl to getFilename
  const getNewNameForDroppedFile = (filenameString, typeString, eORl) => {
    //* this is called multiple times per platform type
    console.log("d101 running, what is typeString(" + typeString + ")");
    // const eORl = inputValues.platform === "elevator" ? "e" : "l"; //doesn't work, we need to know whose calling and what type they are calling with, use typeString
    //* eORl is now an argument

    const baseFilename = getFilename(
      inputValues,
      eORl,
      DATA_PRODUCTS.data[productIndex].label
    );

    // all you are doing here is grabbing the extension.
    // namesplit[length]
    const nameSplit =
      typeof filenameString === "undefined" ? "" : filenameString.split(".");
    const ext = nameSplit[nameSplit.length - 1];
    console.log("d101 nameSplit =", nameSplit, "and extension = ", ext);
    const videoOrImageString = ext === "mp4" ? "video" : "image";
    let returnValue = "";

    if (typeof filenameString === "undefined") {
      console.log("d101, filenameString is undefined.");
      returnValue = undefined;
    } else if (typeString === "svg") {
      returnValue = `${baseFilename}.${ext}`;
    } else if (typeString === "standardAd") {
      returnValue = `${baseFilename}.${ext}`;
    } else if (typeString === "p") {
      returnValue = `${baseFilename}_p${videoOrImageString}.${ext}`;
    } else {
      returnValue = `${baseFilename}_${eORl}${videoOrImageString}.${ext}`;
    }

    return returnValue;
  };

  // these functions are called when landing on the Results page.
  // they make the arrays that display in the text areas that show filed received and to be delivered
  // Keep in mind, these are not the same file names that are used to create the files put in the zip file.
  // these are just for display.
  // creates an array of all the new file names of files that were dropped

  const getAllDroppedNewFilenames = () => {
    return [
      getNewNameForDroppedFile(elevatorFile.name, "e", "e"),
      getNewNameForDroppedFile(lfdFile.name, "l", "l"),
      getNewNameForDroppedFile(pfdFile.name, "p", "l"),
      getNewNameForDroppedFile(svgFile.name, "svg", ""),
      getNewNameForDroppedFile(standardAdFile.name, "standardAd", "e")
    ];
  };
  // creates an array of all names of files that were dropped.
  const getAllDroppedFilenames = () => {
    return [
      elevatorFile.name,
      lfdFile.name,
      pfdFile.name,
      svgFile.name,
      standardAdFile.name
    ];
  };
  ////////////////////////////////////////////////////////

  const handleBackButton = () => {
    if (currentPageNumber > 1 && currentPageNumber < 4) {
      setCurrentPageNumber(currentPageNumber - 1);
    } else if (
      currentPageNumber === 1 &&
      typeof onBackToLanding === "function"
    ) {
      onBackToLanding();
    }
  };

  const circleButtonClickHandler = e => {
    const numberValue = parseInt(e.target.attributes.dataindex.value);
    setCurrentPageNumber(numberValue);
  };

  const handleELPNavClick = e => {
    const val = parseInt(e.target.dataset.value);
    setCurrentBuildNavNumber(val);
  };
  function onlyLettersAndNumbers(str) {
    return /^[A-Za-z0-9-]*$/.test(str);
  }

  const takeScreenshot = () => {
    console.log("taking screenshot");
    // the only place that this function is called is when there are no errors
    // on page 2 and it is time to go to page 3.  Because of this it is ok
    // to have a useEffect for state value SCREENSHOT.  When it changes, go to page 3
    // but unfortunately when moving back from 3 to 2 with numubers button and then
    // not changing the image means that the screen shot will be retaken but not changed
    // because the image taken is the same as the previous one.  This is fixed by adding
    // a random number to the screenshot state so it changes with every update
    //* htmlToImage.toPng(document.getElementById("screenGrabThis")).then(function(dataUrl) {

    //* we now have screenGrabLobby and screenGrabElevator instead of screenGrabThis
    //* each of these is now located in LobbySection and ElevatorSection respectivly
    htmlToImage
      .toPng(document.getElementById("screenGrabElevator"))
      .then(function(dataUrlElevator) {
        let randomValue = Math.random();
        // setScreenshot([dataUrlElevator, randomValue]);
        setScreenshots(prev => ({
          ...prev,
          lobby: [dataUrlElevator, randomValue]
        }));
        console.log("Elevator screenshot is done.");
      })
      .catch(() => {
        console.log("there was an error taking the screenshot for elevator");
      });

    htmlToImage
      .toPng(document.getElementById("screenGrabLobby"))
      .then(function(dataUrlLobby) {
        let randomValue = Math.random();
        // setScreenshot([dataUrlLobby, randomValue]);
        setScreenshots(prev => ({
          ...prev,
          lobby: [dataUrlLobby, randomValue]
        }));
        console.log("Lobby screenshot is done.");
      })
      .catch(() => {
        console.log("there was an error taking the screenshot for lobby");
      });
  };

  const hexColorRegex = /^#([A-Fa-f0-9]{6})$/;

  // Refs for child sections
  const elevatorRef = useRef();
  const lobbyRef = useRef();

  const handleContinueButtonPressed = () => {
    console.log("CLICK! - handleContinueButtonPressed()");
    setInputsCheckButtonPressedOnce(true);
    switch (currentPageNumber) {
      case 1:
        handlePage1Continue();
        break;
      case 2:
        handlePage2Continue();
        // else, errors will be shown in each section
        break;
      case 3:
        console.log("Create Ad Files button clicked");
        console.log("... what is elevatorFilename: " + elevatorFilename);
        console.log("... what is LobbyFilename: " + lobbyFilename);
        deliverTemplateFiles();
        break;
      case 4:
        resetStateToBeginning();
        break;
      default:
        break;
    }
  };
  /////

  /////
  const handlePage1Continue = () => {
    // moving from inputs to Elevator or LFD
    // check if all values filled in
    //* old values that were removed for programmatic:
    // inputValues.duration inputValues.client onlyLettersAndNumbers(inputValues.client) onlyLettersAndNumbers(inputValues.campaign) inputValues.campaign &&  &&inputValues.platform
    if (
      inputValues.creativeID &&
      inputValues.partner &&
      inputValues.product !== undefined &&
      inputValues.countryCode
    ) {
      handleWarningMessageText("", false);
      setInputsCheckButtonPressed(false);
      setCurrentPageNumber(2);
      handleWarningMessageText("drag and drop or click for upload", false);
      console.log("programmatic script, handlePage1Continue(), go to page 2");
    } else {
      console.log(
        "programmatic script, handlePage1Continue(), there was an invalid inputValue"
      );
      handleWarningMessageText("input not complete.", true);
      setInputsCheckButtonPressed(true);
      // set back to false so that error animations will play again
      setTimeout(() => {
        setInputsCheckButtonPressed(false);
      }, "2000");
    }
  };
  /////

  /////
  const handlePage2Continue = () => {
    //* new validations, but we might not need these, double check this later and if not delete them
    // Validate both sections before proceeding
    var elevatorValid =
      elevatorRef.current && elevatorRef.current.validate
        ? elevatorRef.current.validate()
        : true;
    var lobbyValid =
      lobbyRef.current && lobbyRef.current.validate
        ? lobbyRef.current.validate()
        : true;
    if (elevatorValid && lobbyValid) {
      // Call file creation for both sections and store results
      var elevatorFilesCreated =
        elevatorRef.current && elevatorRef.current.createFiles
          ? elevatorRef.current.createFiles()
          : null;
      var lobbyFilesCreated =
        lobbyRef.current && lobbyRef.current.createFiles
          ? lobbyRef.current.createFiles()
          : null;
      setElevatorResults(elevatorFilesCreated);
      setLobbyResults(lobbyFilesCreated);
    }

    // this runs when landing on the RESULTS  page.
    //* likely runs before moving to results page technically
    // check if all dropboxes have been filled
    // check if proper files dropped
    console.log("handlePage2Continue()");
    const missingFilesArray = [];
    const validateFile = (file, fileName) => {
      if (!file.payload) {
        //* give user error message feedback
        setShakeDropzoneBGImage(true);
        setTimeout(() => setShakeDropzoneBGImage(false), 2000);
        missingFilesArray.push(fileName);
        return 1;
      }
      return 0;
    };

    let checkErrors = 0;

    if (!hexColorRegex.test("#" + bintBGColor)) {
      handleWarningMessageText("Please enter a valid 6-digit hex color.", true);
      return; // Exit early if hex color is invalid
      // } else if (noBintImages) {
    } else {
      checkErrors += validateFile(elevatorFile, "elevator");
      checkErrors += validateFile(lfdFile, "lfd");
      checkErrors += validateFile(pfdFile, "pfd");
    }

    // check for svg
    if (inputValues.product === 4) {
      checkErrors += validateFile(svgFile, "svg");
    }

    if (checkErrors === 0) {
      okToGoToPageThree();
    } else if (
      !isElevator &&
      (inputValues.product === 1 || inputValues.product === 3) &&
      checkErrors === 1
    ) {
      // lfsa or lvsa and 1 error, show overlay
      console.log("lfsa or lvsa error, show popup message");
      setShowPopUp(true);
      setPopUpMessage(
        "The same asset will be used for both landscape and portrait."
      );
    } else {
      // elevator or lobby bint, lobby hfsp, lobby fsbi and errors > 0,
      // show the error text
      console.log("files missing, call handleWarningMessage");
      handleWarningMessageText(`files missing: ${missingFilesArray}`, true);
    }
  };
  /////

  /////
  const okToGoToPageThree = () => {
    handleWarningMessageText("", false);
    // Set elevator and lobby filenames using getFilename
    const productNumber = parseInt(inputValues.product);
    const productLabel = DATA_PRODUCTS.data[productNumber].label;
    //setFilename(getFilename); //old

    //* creates a new object by spreading inputValues and then adding/overwriting the platform property with "elevator" or "lobby" for the purpose of calling getFilename.
    //* This new object is only used as an argument for getFilename and does *not* update your inputValues state.
    //* productLabel may no longer be needed, look into deleting it
    setElevatorFilename(
      getFilename({ ...inputValues, platform: "elevator" }, "e", productLabel)
    );
    setLobbyFilename(
      getFilename({ ...inputValues, platform: "lobby" }, "l", productLabel)
    );

    setRequiresBlankFile(DATA_PRODUCTS.data[productNumber].requiresBlankFile);

    setAllDroppedFilenames(getAllDroppedFilenames);
    setAllDroppedNewFilenames(getAllDroppedNewFilenames);

    //* these console logs are unhelpful bc you can't check the states yet, it would be better to create a local var and log that instead
    // console.log("okToGoToPageThree() filename: ", filename);
    // console.log("okToGoToPageThree() ElevatorFilename: ", elevatorFilename);
    // console.log("okToGoToPageThree() LobbyFilename: ", lobbyFilename);

    // there is a bug.  when using the number buttons to return from pg
    // 3 to 2 and then hitting continue again, user can't get to page 3
    // because you only go to page 3 after screenshot changes.  by not dropping
    // a new file, screenshot does not change.  it just takes an image of the
    // same div
    takeScreenshot();
  };
  /////

  useEffect(() => {
    console.log("screenshot changed");
    if (currentPageNumber === 2) {
      setCurrentPageNumber(3);
    }
  }, [screenshots]);
  // }, [screenshot]);

  const resetStateToBeginning = () => {
    console.log("resetStateToBeginning, reloading window.");
    window.location.reload();
  };

  // runs when product changes to set productIndex, isElevator, isFullScreen
  const effectHandleProductChange = () => {
    setProductIndex(inputValues.product);
    // clear all files and previews
    setElevatorFile({});
    setLfdFile({});
    setPfdFile({});
    setSvgFile({});
    setStandardAdFile({});
  };

  useEffect(() => {
    effectHandleProductChange();
  }, [inputValues.product, inputValues.platform]);

  // runs when product changes to set productIndex, isElevator, isFullScreen
  const effectHandlePlatformChange = () => {
    // clear all files and previews
    setElevatorFile({});
    setLfdFile({});
    setPfdFile({});
    setSvgFile({});
    setStandardAdFile({});
  };

  // handler for all inputs
  const handleAnyInputsChange = (name, value) => {
    // if this is setting elevator or lobby, change currentAdBuildingPageNumber to show either elev or lfp
    if (name === "platform") {
      if (value === "elevator") {
        setIsElevator(true);
      } else {
        setIsElevator(false);
      }
    }

    setInputValues(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  /////////////////////////////////////////////////
  //* this was refactored into ElevatorSection.js and LobbySection.js to help keep things seperated
  // const handleDropzoneChanges = (name, value, droppedFileType) => {}

  ///////////////////////////////////////////////
  // * zip 'em up

  const deliverTemplateFiles = () => {
    console.log("deliverTemplateFiles()");
    console.log(
      " ------------------->> what is elevatorFilename:",
      elevatorFilename
    );
    console.log(" ------------------->> what is lobbyFilename:", lobbyFilename);
    console.log(
      " ------------------->> what is mediaExtensions:",
      mediaExtensions
    );
    console.log(
      " ------------------->> what is inputValues.partner:",
      mediaExtensions
    );
    console.log(
      " ------------------->> what is mediaExtensions.elevator:",
      mediaExtensions.elevator
    );
    console.log(
      " ------------------->> what is mediaExtensions.elevator:",
      mediaExtensions.landscape
    );
    console.log(
      " ------------------->> what is mediaExtensions.elevator:",
      mediaExtensions.portrait
    );

    if (elevatorResults && elevatorFilename) {
      // should all the code be wrapped in a if or try/catch?
    } else {
      console.error("deliverTemplateFiles for elevator failed");
    }
    // HTML file
    //* ELEVATOR
    // valH is the text of the html template passed from TemplateCreator
    let contentH = getHTMLFile(
      elevatorFilename,
      isElevator,
      mediaExtensions,
      productIndex,
      bintBGColor,
      isBlackText,
      noBintImages,
      defaultBintBGColor,
      inputValues.partner
    );
    let blobH = new Blob([contentH], {
      type: "text/plain;charset=utf-8"
    });

    // manifest file
    // valM is the text of the manifest template passed from TemplateCreator
    var contentM = getManifestFile(
      noBintImages,
      elevatorFilename,
      isElevator,
      mediaExtensions,
      inputValues.partner
    );
    var blobM = new Blob([contentM], {
      type: "text/plain;charset=utf-8"
    });

    let blobBH;
    let blobBM;

    if (requiresBlankFile) {
      // blank HTML file
      let contentBH = getBlankHTML(blankFilename, inputValues.partner);
      blobBH = new Blob([contentBH], {
        type: "text/plain;charset=utf-8"
      });

      // blank manifest file
      var contentBM = getBlankManifest(blankFilename, inputValues.partner);
      blobBM = new Blob([contentBM], {
        type: "text/plain;charset=utf-8"
      });
    }
    ///////////////////////////////////////
    // at this point all the manifests are done. Now you need to
    // do the async stuff like loading images and videos

    let newZip = new JSZip();
    newZip.file(`${elevatorFilename}.html`, blobH);
    newZip.file(`${elevatorFilename}.manifest`, blobM);

    console.log("mediaExtensions.elevator:", mediaExtensions.elevator);

    const loadElevator = elevatorFile.payload
      ? elevatorFile.payload.arrayBuffer().then(result => {
          console.log("deliverTemplateFiles()) actual results:", result);
          newZip.file(
            `${elevatorFilename}_e${
              mediaExtensions.elevator === "mp4" ? "video" : "image"
            }.${mediaExtensions.elevator}`,
            result
          );
        })
      : "";
    // Debug: log the contents of loadElevator
    console.log("deliverTemplateFiles() loadElevator:", loadElevator);

    const loadSVG = svgFile.payload
      ? svgFile.payload.arrayBuffer().then(result => {
          newZip.file(`${lobbyFilename}.svg`, result);
        })
      : "";

    // if this is a lobby 1 file and the source is a pfd, pfd is the source
    // else, lfd is the source
    //* LOBBY
    // HTML file
    // valH is the text of the html template passed from TemplateCreator
    const isElevatorIsFALSE = false; // *just to make it damn well clear that this is not elevator!
    let contentH_Lobby = getHTMLFile(
      lobbyFilename,
      isElevatorIsFALSE,
      mediaExtensions,
      productIndex,
      bintBGColor,
      isBlackText,
      noBintImages,
      defaultBintBGColor,
      inputValues.partner
    );
    let blobH_Lobby = new Blob([contentH_Lobby], {
      type: "text/plain;charset=utf-8"
    });

    // manifest file
    // valM is the text of the manifest template passed from TemplateCreator
    var contentM_Lobby = getManifestFile(
      noBintImages,
      lobbyFilename,
      isElevatorIsFALSE,
      mediaExtensions,
      inputValues.partner
    );
    var blobM_Lobby = new Blob([contentM_Lobby], {
      type: "text/plain;charset=utf-8"
    });

    // if blank file
    let blobBH_Lobby;
    let blobBM_Lobby;

    if (requiresBlankFile) {
      // blank HTML file
      let contentBH_Lobby = getBlankHTML(
        blankFilenameLobby,
        inputValues.partner
      );
      blobBH_Lobby = new Blob([contentBH_Lobby], {
        type: "text/plain;charset=utf-8"
      });

      // blank manifest file
      var contentBM_Lobby = getBlankManifest(
        blankFilenameLobby,
        inputValues.partner
      );
      blobBM_Lobby = new Blob([contentBM_Lobby], {
        type: "text/plain;charset=utf-8"
      });
    }
    ///////////////////////////////////////
    // at this point all the manifests are done. Now you need to
    // do the async stuff like loading images and videos

    let newZip_Lobby = new JSZip();
    newZip_Lobby.file(`${lobbyFilename}.html`, blobH_Lobby);
    newZip_Lobby.file(`${lobbyFilename}.manifest`, blobM_Lobby);

    //const lfdSource = lobbyAndOneAsset && lobbyAndOneAssetIsLFD === false ? pfdFile : lfdFile; //* dont need this anymore delete
    // i think this will be fine because you no longer have any situation where lfd or pfd are empty
    const loadLFD = lfdFile.payload
      ? lfdFile.payload.arrayBuffer().then(result => {
          newZip_Lobby.file(
            `${lobbyFilename}_l${
              mediaExtensions.landscape === "mp4" ? "video" : "image"
            }.${mediaExtensions.landscape}`,
            result
          );
        })
      : "";

    //const pfdSource = lobbyAndOneAsset && lobbyAndOneAssetIsLFD ? lfdFile : pfdFile;
    const loadPFD = pfdFile.payload
      ? pfdFile.payload.arrayBuffer().then(result => {
          newZip_Lobby.file(
            `${lobbyFilename}_p${
              mediaExtensions.portrait === "mp4" ? "video" : "image"
            }.${mediaExtensions.portrait}`,
            result
          );
        })
      : "";

    //* we might just get away with using the same svg for both ele and lby, come back to this later if needed
    // const loadSVG_Lobby = svgFile.payload
    //   ? svgFile.payload.arrayBuffer().then(result => {
    //       newZip.file(`${lobbyFilename}.svg`, result);
    //     })
    //   : "";

    // const loadStandardAd = standardAdFile.payload
    //   ? standardAdFile.payload.arrayBuffer().then((result) => {
    //       newZip.file(`${finalStandardAdFilename}.mp4`, result);
    //     })
    //   : "";

    const loadObject = [
      { file: elevatorFile, fn: loadElevator },
      { file: svgFile, fn: loadSVG }
      // { file: standardAdFile, fn: loadStandardAd },
    ];
    const loadObject_Lobby = [
      { file: lfdFile, fn: loadLFD },
      { file: pfdFile, fn: loadPFD },
      { file: svgFile, fn: loadSVG }
      // { file: standardAdFile, fn: loadStandardAd },
    ];
    const promiseArray = loadObject.map(obj => {
      if (obj.file.payload) {
        return obj.fn;
      } else return null;
    });
    const promiseArray_Lobby = loadObject_Lobby.map(obj => {
      if (obj.file.payload) {
        return obj.fn;
      } else return null;
    });

    //PROMISE ELEVATOR ZIP
    Promise.all(promiseArray)
      .then(e => {
        if (requiresBlankFile) {
          newZip.file(`${blankFilename}.html`, blobBH);
          newZip.file(`${blankFilename}.manifest`, blobBM);
        }

        // newZip.generateAsync({ type: "blob" }).then(function(content) {
        //   saveAs(content, `${filename}.zip`);
        // });
        newZip.generateAsync({ type: "blob" }).then(function(content) {
          saveAs(content, `${elevatorFilename}.zip`);
        });
      })
      .then(e => {
        console.log("finished elevator zip");
        // if success, show final screen
        // final screen will always say 'downloading' and no way to see when finished.
        setCurrentPageNumber(4);
      })
      .catch(e => {
        console.log("zip error");
      });

    //PROMISE LOBBY ZIP
    Promise.all(promiseArray_Lobby)
      .then(e => {
        if (requiresBlankFile) {
          newZip_Lobby.file(`${blankFilenameLobby}.html`, blobBH_Lobby);
          newZip_Lobby.file(`${blankFilenameLobby}.manifest`, blobBM_Lobby);
        }

        // newZip.generateAsync({ type: "blob" }).then(function(content) {
        //   saveAs(content, `${filename}.zip`);
        // });
        newZip_Lobby.generateAsync({ type: "blob" }).then(function(content) {
          saveAs(content, `${lobbyFilename}.zip`);
        });
      })
      .then(e => {
        console.log("finished lobby zip");
        // if success, show final screen
        // final screen will always say 'downloading' and no way to see when finished.
        setCurrentPageNumber(4);
      })
      .catch(e => {
        console.log("zip error");
      });

    // After both, go to final screen
    setCurrentPageNumber(4); //* ?
  };

  // next step is to set opacity to .5 when setting to default background
  // and setting back to 1 when unsetting default bg

  const handleBINTColorChange = color => {
    // Allow only hex characters (0-9, a-f, A-F)
    const sanitizedColor = color.replace(/[^0-9a-fA-F]/g, "");
    setBintBGColor(sanitizedColor);
    // still need to only allow 6 character colors.
    // probably need to separate the characters shown (not valid colors)
    // and the actual color.  On 6 characters set actual color.  but as you
    // get to 6, show the hex only characters.
  };
  const handleBlackWhiteToggleChange = () => {
    setIsBlackText(prevIsBlackText => !prevIsBlackText);
  };
  const handleNoImagesToggleChange = () => {
    setNoBintImages(prevNoBintImages => !prevNoBintImages);
    // clear out all dropped images
    effectHandlePlatformChange();
    setElevatorFile({});
    setLfdFile({});
    setPfdFile({});

    // clear out dropzoneImageParent
    const eToClear = document.querySelector(".ebintAd .dropzoneImageParent");
    const lToClear = document.querySelector(".lBintAd .dropzoneImageParent");
    const pToClear = document.querySelector(".pBintAd .dropzoneImageParent");

    while (eToClear.firstChild) {
      eToClear.removeChild(eToClear.lastChild);
    }
    while (lToClear.firstChild) {
      lToClear.removeChild(lToClear.lastChild);
    }
    while (pToClear.firstChild) {
      pToClear.removeChild(pToClear.lastChild);
    }
  };

  const handleDefaultBintBGColorChange = () => {
    console.log("changed");

    defaultBintBGColor ? setBintBGOpacity(1) : setBintBGOpacity(0.2);
    setDefaultBintBGColor(prevDefaultBintBGColor => !prevDefaultBintBGColor);
    setIsBlackText(false);
    setBintBGColor("000000");
  };

  // Log all items inside inputValues
  Object.keys(inputValues).forEach(key => {
    // console.log(`inputValues.${key}:`, inputValues[key]);
  });

  console.log("what is currentPageNumber: ", currentPageNumber);

  return (
    <div className="progLayout appContainer flexColumnCenterClass">
      {currentPageNumber !== 4 ? (
        <BackButton handleBackButton={handleBackButton} />
      ) : null}
      <div className={`topSub`}>
        {currentPageNumber !== 4 ? (
          <Filename inputValues={inputValues} />
        ) : null}
        {/* move warning message to nav sub */}
        {/* {currentPageNumber !== 4 ? (
          <WarningMessage
            warningMessageText={warningMessageText}
            warningMessageTextShowIcon={warningMessageTextShowIcon}
          />
        ) : null} */}
        {currentPageNumber === 2 && !isElevator ? (
          <div className="elpNavigatorContainer">
            <div
              data-value="1"
              onClick={handleELPNavClick}
              className={`elpNavButton ${
                currentBuildNavNumber === 1 ? "current" : "enabled"
              }`}
            >
              LFD
            </div>
            <div
              data-value="2"
              onClick={handleELPNavClick}
              className={`elpNavButton ${
                currentBuildNavNumber === 2
                  ? "current"
                  : inputValues.product === 1 &&
                    !isElevator &&
                    Object.keys(lfdFile).length === 0
                  ? "disabled"
                  : "enabled"
              }`}
            >
              PFD
            </div>
          </div>
        ) : null}

        {currentPageNumber === 2 && inputValues.product === 0 ? (
          <BlackWhiteToggleButton
            handleDefaultBintBGColorChange={handleDefaultBintBGColorChange}
            handleBINTColorChange={handleBINTColorChange}
            isBlackText={isBlackText}
            noBintImages={noBintImages}
            defaultBintBGColor={defaultBintBGColor}
            bintBGColor={bintBGColor}
            handleBlackWhiteToggleChange={handleBlackWhiteToggleChange}
            handleNoImagesToggleChange={handleNoImagesToggleChange}
          >
            {" "}
          </BlackWhiteToggleButton>
        ) : null}
      </div>
      <div className="contentSub">
        {/* PAGE 1 */}
        {/* {`adBuildingPageInner ${currentBuildNavNumber === 2 ? "hide" : ""}`} */}

        {currentPageNumber !== 4 ? (
          <div
            className={`inputsPage page ${
              currentPageNumber !== 1 ? "hide" : ""
            }`}
          >
            <Inputs
              productIndex={productIndex}
              inputValues={inputValues}
              handleAnyInputsChange={handleAnyInputsChange}
              inputsCheckButtonPressed={inputsCheckButtonPressed}
              inputsCheckButtonPressedOnce={inputsCheckButtonPressedOnce}
            />
          </div>
        ) : null}

        {/* PAGE 2 */}
        <div
          className={`adBuildingPage${currentPageNumber === 3 ? " hide" : ""}`}
          style={{
            display: currentPageNumber === 2 ? "flex" : "none",
            gap: "2em"
          }}
        >
          {/* Render ElevatorSection and LobbySection side-by-side */}
          <OpacityContext.Provider
            value={{
              bintBGOpacity,
              isBlackText,
              noBintImages,
              bintBGColor,
              productIndex,
              svgFile,
              shakeDropzoneBGImage,
              elevatorFile,
              lfdFile,
              pfdFile,
              setLfdFile,
              setPfdFile
            }}
          >
            <ElevatorSection
              // id={isElevator ? "screenGrabThis" : null} // set up this ID in ElevatorSection as id={"screenGrabElevator"}
              ref={elevatorRef}
              inputValues={inputValues}
              onElevatorFileChange={setElevatorFile}
              onWarningMessage={handleWarningMessageText}
              setMediaExtensions={setMediaExtensions}
            />
            <LobbySection
              ref={lobbyRef}
              inputValues={inputValues}
              currentBuildNavNumber={currentBuildNavNumber}
              onLfdFileChange={setLfdFile}
              onPfdFileChange={setPfdFile}
              onWarningMessage={handleWarningMessageText}
              setMediaExtensions={setMediaExtensions}
            />
          </OpacityContext.Provider>
        </div>

        {/* PAGE 3 */}
        <div
          className={`resultsPage page ${
            currentPageNumber !== 3 ? "hide" : ""
          }`}
        >
          {/* Debug log before rendering Results page */}
          {currentPageNumber === 3 && (
            <>
              {console.log("[ResultsPage] elevatorFile:", elevatorFile)}
              {console.log("[ResultsPage] lfdFile:", lfdFile)}
              {console.log("[ResultsPage] pfdFile:", pfdFile)}
            </>
          )}
          <ProgResults
            elevatorResults={elevatorResults}
            lobbyResults={lobbyResults}
            inputValues={inputValues}
            // screenshot={screenshot}
            screenshots={screenshots}
            elevatorFile={elevatorFile}
            lfdFile={lfdFile}
            pfdFile={pfdFile}
          />
        </div>
      </div>

      <div className="navSubSticky">
        <div className="navSub flexColumnCenterClass">
          {currentPageNumber !== 4 ? (
            <WarningMessage
              warningMessageText={warningMessageText}
              warningMessageTextShowIcon={warningMessageTextShowIcon}
            />
          ) : null}
          {currentPageNumber !== 4 ? (
            <div className="buttonsHolder">
              <div
                onClick={circleButtonClickHandler}
                dataindex={1}
                className={`circleButton ${
                  currentPageNumber === 1 ? "current" : "enabled"
                }`}
              >
                1
              </div>
              <div
                onClick={circleButtonClickHandler}
                dataindex={2}
                className={`circleButton ${
                  currentPageNumber === 2
                    ? "current"
                    : currentPageNumber > 2
                    ? "enabled"
                    : "disabled"
                }`}
              >
                2
              </div>
              <div
                onClick={circleButtonClickHandler}
                dataindex={4}
                className={`circleButton ${
                  currentPageNumber === 3 ? "current" : "disabled"
                }`}
              >
                3
              </div>
            </div>
          ) : null}

          <ContinueButton
            currentPageNumber={currentPageNumber}
            handleContinueButtonPressed={handleContinueButtonPressed}
            continueButtonDisabled={continueButtonDisabled}
          ></ContinueButton>
        </div>
      </div>
    </div>
  );
}
